'use strict';

function VehiclePublicIDTransformer(
	Util,
	jsonMapper,
	serviceResponseRepository,
	aggregatedRemoveService
) {
	var currentResponse = null;
	var driverUniqueIdCtr = 1;
	var historyUniqueIdCtr = 1;

	function forgePublicId(moduleName) {
		return Util.stringFormat(
			'portal:{0}-{1}',
			moduleName,
			Util.generateRandomString(15)
		);
	}

	function hasValidGWPublicID(publicID) {
		if (publicID && publicID.indexOf('portal:') === -1) return true;

		return false;
	}

	function hash(value) {
		return md5(value);
	}

	function fetchFromPreviousResponse(path) {
		if (currentResponse)
			return Util.findHierarchyStringInObject(currentResponse, path, '.');

		return null;
	}

	function convertPublicID(path, moduleName) {
		if (currentResponse) {
			var lastPublicID = fetchFromPreviousResponse(path);
			if (lastPublicID) return lastPublicID;
		}

		return forgePublicId(moduleName);
	}

	var moduleNameMapping = {
		policyHolders: 'PolicyHolder[]',
		policyAddress: 'Address',
		vehicles: 'QPMVehicle',
		driver: 'QPMVehicleDriver',
		policyDriver: 'QPMPolicyDriver',
		person: 'person',
		driverHistory: 'QPMDriverHistory',
		drivingHistory: 'QPMDrivingHistory',
		pattern: 'qbePattern'
	};

	var publicIDTransformationMapping = {
		'policyAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'vehicles.0.publicID': function() {
			return forgePublicId(moduleNameMapping.vehicles);
		},
		'vehicles.0.garageAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'vehicles.0.drivers.*.publicID': function() {
			return forgePublicId(moduleNameMapping.driver);
		},
		'vehicles.0.drivers.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'vehicles.0.drivers.*.driver.publicID': function() {
			return forgePublicId(moduleNameMapping.policyDriver);
		},
		'vehicles.0.drivers.*.driver.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'vehicles.0.drivers.*.driver.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		},
		'vehicles.0.drivers.*.driver.driverHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.driverHistory);
		},
		'vehicles.0.drivers.*.driver.driverHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'policyHolders.*.contact.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function() {
			return forgePublicId(moduleNameMapping.drivingHistory);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		}
	};

	var authorisedPersonsPublicIDTransformationMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function() {
			return forgePublicId(moduleNameMapping.person);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function() {
			return forgePublicId(moduleNameMapping.policyAddress);
		}
	};

	var publicIDConversionMapping = {
		'policyAddress.publicID': function(val) {
			return convertPublicID(
				'policyAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'vehicles.0.publicID': function(val) {
			return convertPublicID(
				'vehicles.0.publicID',
				moduleNameMapping.vehicles
			);
		},
		'vehicles.0.drivers.*.uniqueID': function() {
			return driverUniqueIdCtr++;
		},
		'vehicles.0.drivers.*.driver.driverHistory.*.uniqueID': function() {
			return historyUniqueIdCtr++;
		},
		'vehicles.0.garageAddress.publicID': function(val) {
			return convertPublicID(
				'vehicles.0.garageAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.publicID',
				moduleNameMapping.policyHolders
			);
		},
		'vehicles.0.drivers.*[driverUsage].publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' + mappedValueStarIndices[0] + '.publicID',
				moduleNameMapping.driver
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'.driver.publicID',
				moduleNameMapping.policyDriver
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.person.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'.driver.person.publicID',
				moduleNameMapping.person
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.driverHistory.*.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'.driver.driverHistory.' +
					mappedValueStarIndices[1] +
					'.publicID',
				moduleNameMapping.driverHistory
			);
		},
		'vehicles.0.drivers.*[driverUsage].driver.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'vehicles.0.drivers.' +
					mappedValueStarIndices[0] +
					'driver.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolder.' +
					mappedValueStarIndices[0] +
					'.contact.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		},
		'policyHolders.*.contact.drivingHistory.*.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.drivingHistory.' +
					mappedValueStarIndices[1] +
					'.publicID',
				moduleNameMapping.drivingHistory
			);
		}
	};

	var authorisedPersonsPublicIDConversionMapping = {
		'policyHolders.*.contact.authorisedPersons.0.person.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.publicID',
				moduleNameMapping.person
			);
		},
		'policyHolders.*.contact.authorisedPersons.0.person.primaryAddress.publicID': function(
			val,
			mappedValueStarIndices
		) {
			return convertPublicID(
				'policyHolders.' +
					mappedValueStarIndices[0] +
					'.contact.authorisedPersons.0.person.primaryAddress.publicID',
				moduleNameMapping.policyAddress
			);
		}
	};

	function removeDeletedAdditionalDrivers(transformedRequest) {
		var removedDrivers = aggregatedRemoveService.getList()
			? aggregatedRemoveService.getList()['driver']
			: null;
		var savedDrivers = fetchFromPreviousResponse('drivers.0.drivers');
		if (savedDrivers && removedDrivers) {
			angular.forEach(removedDrivers, function(removedDriver) {
				var matchingDriver = savedDrivers.filter(function(driver) {
					return (
						driver.driver.person.firstName ==
							removedDriver.person.firstName &&
						driver.driver.person.lastName ==
							removedDriver.person.lastName
					);
				});
				matchingDriver = matchingDriver[0] || null;
				if (matchingDriver) {
					matchingDriver.markedForDelete = true;
					transformedRequest.drivers[0].drivers.push(matchingDriver);
				}
			});
			aggregatedRemoveService.clear('driver');
		}

		return transformedRequest;
	}

	function removeDeletedDriverHistoryArrays(transformedRequest) {
		var drivers = transformedRequest.vehicles[0].drivers;
		var fieldName = 'driverUsage';
		angular.forEach(drivers, function(driver, index) {
			var fieldValue = driver[fieldName];
			var locator = '[' + fieldName + '=' + fieldValue + ']';
			var savedHistories = fetchFromPreviousResponse(
				'vehicles.0.drivers.' +
					index +
					locator +
					'.driver.driverHistory'
			);
			if (savedHistories && savedHistories.length > 0) {
				var driverHistories = driver.driver.driverHistory;
				angular.forEach(savedHistories, function(savedHistory) {
					var matchingInput = driverHistories.filter(function(
						history
					) {
						return history.publicID == savedHistory.publicID;
					});
					if (!matchingInput || matchingInput.length == 0) {
						savedHistory.markedForDelete = true;
						driverHistories.push(savedHistory);
					}
				});
			}
		});
		return transformedRequest;
	}

	function removeEmptyDriverHistoryArrays(transformedRequest) {
		var vehicle = transformedRequest.vehicles[0];
		if (vehicle && vehicle.drivers) {
			vehicle.drivers.forEach(function(policyDriver) {
				if (
					policyDriver.driver &&
					policyDriver.driver.driverHistory &&
					Array.isArray(policyDriver.driver.driverHistory) &&
					policyDriver.driver.driverHistory.length == 0
				)
					delete policyDriver.driver.driverHistory;
			});
		}

		return transformedRequest;
	}

	//dd-973 - requiring a sequence number for driver infringement
	function addUniqueHistoryID(transformedRequest) {
		var drivers = transformedRequest.vehicles[0].drivers;

		angular.forEach(drivers, function(driver, index) {
			historyUniqueIdCtr = 1;
			var driverHistory = driver.driver.driverHistory;
			if (driverHistory) {
				angular.forEach(driverHistory, function(driverHistory, index) {
					driverHistory.uniqueID = historyUniqueIdCtr;
					historyUniqueIdCtr++;
				});
			}

			// if (driver.driverUsage !== 'main') {
			// 	if (driver.driver.person && driver.driver.person.primaryAddress) {
			// 		delete driver.driver.person.primaryAddress;
			// 	}
			// }
		});
		return transformedRequest;
	}

	function transform(intermediateRequest, response) {
		currentResponse = response;
		driverUniqueIdCtr = 1;
		var transformedRequest = intermediateRequest;

		if (
			transformedRequest.policyHolders[0] &&
			transformedRequest.policyHolders[0].contact &&
			transformedRequest.policyHolders[0].contact.authorisedPersons
		) {
			publicIDConversionMapping = Object.extend(
				publicIDConversionMapping,
				authorisedPersonsPublicIDConversionMapping
			);
			publicIDTransformationMapping = Object.extend(
				publicIDTransformationMapping,
				authorisedPersonsPublicIDTransformationMapping
			);
		}

		if (!currentResponse)
			transformedRequest = jsonMapper.transform(
				intermediateRequest,
				publicIDTransformationMapping
			);
		else {
			transformedRequest = jsonMapper.convert(
				intermediateRequest,
				publicIDConversionMapping
			);
		}

		transformedRequest = addUniqueHistoryID(transformedRequest);
		transformedRequest = removeDeletedAdditionalDrivers(transformedRequest);
		transformedRequest = removeDeletedDriverHistoryArrays(
			transformedRequest
		);
		transformedRequest = removeEmptyDriverHistoryArrays(transformedRequest);

		return transformedRequest;
	}

	return {
		transform: transform
	};
}
